import { createSlice } from '@reduxjs/toolkit';

export const generatedMovie = createSlice({
  name: 'movies',
  initialState: [],
  reducers: {
    getGeneratedMovies: (_, { payload }) => payload,
  },
});

export const { getGeneratedMovies } = generatedMovie.actions;
export default generatedMovie.reducer;
